/**
 * Created by Pali on 30/09/22.
 */

angular.module("screensApp").controller("JackpotController", function ($q, $scope, $rootScope, JackpotService) {

  // Show JackpotContainer
  $rootScope.showJackpotContainer = function () {
    if ($rootScope.config.LanguageId === "sk") {
      $scope.jackpotLang = "sk";
    } else {
      $scope.jackpotLang = "en";
    }
    $rootScope.loadJackpotData();
  };

  $rootScope.hideJackpotContainer = function (deleteData) {
    $rootScope.settings.jackpot.show = false;
    if (deleteData) {
      $scope.jackpotWinners = null;
      $scope.jackpotData = null;
    }
  };

  /**
   * Main function for load Jackpot data
   */
  $rootScope.loadJackpotData = function () {
    var deferred = $q.defer();
    JackpotService.getJackpotData()
      .success(function (jackpotData) {
        jackpotData = jackpotData.filter(function (jackpot) {
          if ($rootScope.config.JackpotBetPlatforms.includes(jackpot.BetPlatform) && $rootScope.config.JackpotBetTypes.includes(jackpot.BetType)) {
            jackpot.jackpotType = jackpot.BetType.toLowerCase();
            return jackpot;
          }
        });
        if (jackpotData.length) {
          $scope.jackpotData = jackpotData;
          deferred.resolve(jackpotData);
        } else if ($rootScope.customBanners && $rootScope.customBanners.length) {
          // Banery boli uz inicializovane, jackpoty boli vypnute, treba reload
          $rootScope.closeAllWhenRestart();
          ReloadTop();
        } else {
          deferred.resolve([]);
        }
      })
      .error(function (err) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR AJAX: checkScroll() err: ' + err);
        $rootScope.createLog(3, "TopScreenJackpotError", err.toString());
        $rootScope.hideJackpotContainer(true);
        deferred.reject(err);
      });

    return deferred.promise;
  };

  $rootScope.jackpotDataChanged = function (changedJackpotData) {
    if ($scope.jackpotData && $scope.jackpotData.length) {
      $scope.jackpotData = $scope.jackpotData.map(function (jackpot) {
        if (changedJackpotData.jackpotCode === jackpot.JackpotCode.toLowerCase()) {
          jackpot.JackpotValue = changedJackpotData.jackpotValue;
        }
        return jackpot;
      });
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: jackpotDataChanged() changedJackpotData: ' + JSON.stringify(changedJackpotData));
      $rootScope.$$phase || $rootScope.$apply();
    }
  };

  $rootScope.determineJackpotRender = function () {
    $rootScope.loadJackpotData().then(function (jackpotData) {
      $scope.jackpotData = jackpotData;
      if ($scope.jackpotData.length) {
        if (typeof $scope.jackpotIndex == "undefined") {
          $scope.jackpotIndex = 0;
        } else if ($scope.jackpotData.length - 1 <= $scope.jackpotIndex) {
          $scope.jackpotIndex = 0;
        } else {
          ++$scope.jackpotIndex;
        }
        $scope.jackpotType = $scope.jackpotData[$scope.jackpotIndex].jackpotType;
        $scope.jackpotCode = $scope.jackpotData[$scope.jackpotIndex].JackpotCode;
        $rootScope.loadAndShowJackpotBasedOnActualJackpotData($scope.jackpotData[$scope.jackpotIndex].JackpotCode);
      }
    });
  };

  $rootScope.loadAndShowJackpotBasedOnActualJackpotData = function (jackpotType) {
    JackpotService.getJackpotWinners(jackpotType)
      .success(function (jackpotWinners) {
        var jWinners = 0;
        $scope.jackpotWinners = jackpotWinners.filter(function (jackpotWinner) {
          if (jWinners <= $rootScope.settings.jackpot.jackpotWinnersMaxCount) {
            jackpotWinner.createdDate = moment(jackpotWinner.Created).format("D.M.YYYY");
            jackpotWinner.createdTime = moment(jackpotWinner.Created).format("HH:mm");
            ++jWinners;
            return jackpotWinner;
          }
        });
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# INFO: loadAndShowJackpotBasedOnActualJackpotData() jackpotType: ' + JSON.stringify(jackpotType));
        $rootScope.settings.jackpot.show = true;
      })
      .error(function (err) {
        $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR AJAX: loadAndShowJackpotBasedOnActualJackpotData() err: ' + err.toString());
        $rootScope.hideJackpotContainer(true);
      });
  };
});
